module.exports = __webpack_public_path__ + "media/images/front/products/logiq_v5/index-banner-84cc290b459d3b615ef1105de2f4e162.jpg";